"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LegalDisclaimerPopup_1 = require("./LegalDisclaimerPopup");
exports.default = LegalDisclaimerPopup_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/LegalDisclaimerPopup/index.js
// module id = 528
// module chunks = 8